<template>
  <div class="summaries">
    <div class="columns">
      <div class="column is-full">
        <b-table class="summaries-table" :data="groupedLogsData" :hoverable="true" bordered
                 :mobile-cards="false" :loading="isLoading" :scrollable="true" @click="groupedLogSelected"
                 :show-header="false"
                 :selected.sync="selected_row">
          <b-table-column field="duration_summary" :label="this.$t('grouped-logs.duration-summary-column')"
                          v-slot="props">
            <div v-if="isHavingValue(props.row.grouped_log)" class="columns is-full"
                 style="margin-top: 8px; margin-bottom: 8px;">
              <div class="column has-text-centered is-narrow"> <!-- date -->
                <p style="font-weight: bold">{{ getFormattedDate(props.row.grouped_log.date) }}</p>
                <b-icon v-if="!isProjectSummaryHoursValid(props.row.grouped_log)" icon="alert-circle" size="is-medium"
                        type="is-danger" style="margin-top: 16px"/>
              </div>
              <div class="column"> <!-- profits -->
                <div class="columns is-gapless is-mobile">
                  <div class="column has-text-centered">
                    <p :style="profitTextStyle(props.row.grouped_log.total_profit)">
                      {{ getFormattedPricing(toFixedIfNecessary(props.row.grouped_log.total_profit)) }}</p>
                  </div>
                </div>
                <div class="columns is-gapless">
                  <div class="column is-half"> <!-- negative -->
                    <b-progress v-if="props.row.grouped_log.total_profit < 0" :max="maxProfitValue" size="is-medium">
                      <template #bar>
                        <b-progress-bar :value="maxProfitValue + props.row.grouped_log.total_profit"
                                        type="is-progressbg"></b-progress-bar>
                        <b-progress-bar :value="-(props.row.grouped_log.total_profit)" type="is-danger"></b-progress-bar>
                      </template>
                    </b-progress>
                  </div>
                  <div class="column is-half"> <!-- positive -->
                    <b-progress v-if="props.row.grouped_log.total_profit >= 0" :value="props.row.grouped_log.total_profit"
                                size="is-medium"
                                type="is-success" :max="maxProfitValue"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="columns">
              <div class="column is-narrow"> <!-- date -->
                <p style="font-weight: bold">{{ getFormattedDate(props.row.grouped_log.date) }}</p>
              </div>
            </div>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "GroupedLogs",
  components: {},
  props: {
    'project_id': {
      type: String,
    }
  },
  data() {
    return {
      isLoading: false,
      groupedLogsData: [],
      maxDurationValue: null,
      maxProfitValue: null,
      selected_row: {}
    }
  },
  methods: {
    readProjectSummary: function () {
      this.isLoading = true
      this.groupedLogsData = []
      const functions = firebase.app().functions("europe-west3");
      const getProjectSummaryFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getProjectSummaryFunction({action: "get_project_summary", document_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("get_project_summary result: ", result.data);
            const internalDurations = result.data.grouped_logs.map(log => log.total_logged_durations_internal_personnel);
            const externalDurations = result.data.grouped_logs.map(log => log.total_logged_durations_external_personnel);
            const allDurations = internalDurations.concat(externalDurations)
            this.maxDurationValue = Math.max.apply(Math, allDurations)
            this.maxProfitValue = Math.max.apply(Math, result.data.grouped_logs.map(log => Math.abs(log.total_profit)))
            if (result.data.grouped_logs.length > 0) {
              result.data["grouped_logs"].forEach((grouped_log) => {
                this.groupedLogsData.push({
                  grouped_log: grouped_log
                });
              });
            }
            this.isLoading = false
            if (this.groupedLogsData[0] !== undefined) {
              this.groupedLogSelected(this.groupedLogsData[0])
            }
          })
          .catch((error) => {
            this.isLoading = false
            this.showError(error.message)
            console.log("Error get_project_summary: ", error);
          });
    },
    /*
     UI Events
     */
    groupedLogSelected: function (groupLog) {
      if (this.isHavingValue(groupLog.grouped_log)) {
        this.selected_row = groupLog
      } else {
        this.selected_row = null
      }
      this.$emit("groupLogSelected", groupLog)
    }
  },
  mounted() {
    this.readProjectSummary();
  }
};
</script>

<style scoped>
.summaries-table {
  margin: 0;
}
</style>
